import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";

import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { GlobalState } from "@app/models/state";
import { Icon } from "@ui/Icon";
import { Page, CardBody, CardTitle } from "@ui/Page";
import { BundlesList } from "@upload/components/BundlesList";
import { messages as uMessages } from "@upload/messages";
import { canCreateBundle } from "@upload/selectors";

interface BundlesIndexStateProps {
    canCreate: boolean;
}

const breadcrumbItems = [
    { text: <FormattedMessage {...messages.pageBundlesTitle} /> },
];

const BundlesIndex = ({ canCreate }: BundlesIndexStateProps) => {
    const createButtonProps = {
        tag: Link,
        to: "/bundles/create",
        color: "primary",
    };
    return (
        <Page className="bundles-index-page" breadcrumbs={breadcrumbItems}>
            <CardBody>
                <CardTitle tag="h1">
                    <FormattedMessage {...uMessages.bundleEntityPlural} />
                </CardTitle>
                { canCreate &&
                    <Button {...createButtonProps}>
                        <Icon name="upload" />
                        {" "}
                        <FormattedMessage {...uMessages.uploadNewBundle} />
                    </Button>
                }
            </CardBody>
            <BundlesList />
        </Page>
    );
};

const mapStateToProps = (state: GlobalState) => ({
    canCreate: canCreateBundle(state),
});

const ConnectedBundlesIndex = compose<BundlesIndexStateProps, {}>(
    setTitleOnPage(messages.pageBundlesTitle),
    connect(mapStateToProps, null),
)(BundlesIndex);

export {
    BundlesIndex as BundlesIndexPresenter,
    ConnectedBundlesIndex as BundlesIndex,
};
